import { render, staticRenderFns } from "./ContentPlaceholder.vue?vue&type=template&id=296b8619&scoped=true&"
import script from "./ContentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ContentPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ContentPlaceholder.vue?vue&type=style&index=0&id=296b8619&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b8619",
  null
  
)

export default component.exports